import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Authentication Callback Component
 * Handles the redirect from Azure AD after authentication
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Redirect to home after authentication
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        navigate("/");
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, navigate]);

  return (
    <div className="auth-callback-container">
      <div className="auth-callback-content">
        <div className="spinner"></div>
        <h2>Authenticating...</h2>
        <p>Please wait while we complete your sign-in</p>
      </div>

      <style jsx>{`
        .auth-callback-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }

        .auth-callback-content {
          text-align: center;
          color: white;
        }

        .spinner {
          width: 60px;
          height: 60px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        h2 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        p {
          font-size: 16px;
          opacity: 0.9;
        }
      `}</style>
    </div>
  );
};

export default AuthCallback;
